import { gql } from "@apollo/client";

export const GET_ROLE_DISPATCHING_BY_UNIT_SHORTNAME = gql`
    query getRoleDispatchingByUnitShortname($unitShortname: String!){
        rd: publicRoleDispatchings(role_committee_unit_shortTitle: $unitShortname) {
            role {
                title
            }
            member {
                memberNumber
                fullName
                primaryEmail
                avatar
                facebook
                linkedin
                instagram
            }
        }
    }
`;
